import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, TextField, Box } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import { saveRondasAction } from '../RondasAction';
import { validMessage } from '../../../../constants/ValidsFormConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { useNotification } from '../../../../helpers/Notification';

const FormRondas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const torneosStore = Redux.useSelector((state) => state.torneos);
  const rondasStore = Redux.useSelector((state) => state.rondas);

  const activo = rondasStore.activo;

  const initData = {
    nombre: '',
    desc: '',
    posicion: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    posicion: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!torneosStore.activo) {
      notify('Falta seleccionar un torneo', { warning: true });
      return;
    }

    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveRondasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idTorneo: torneosStore.activo.id,
        },
        rondasStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.posicion.name}
            required
            label={CONST.posicion.label}
            value={data.posicion}
            onChange={(e) =>
              _handleSetDataField(CONST.posicion.name, Number(e.target.value))
            }
            helperText={dataError.posicion ? validMessage.required : null}
            error={dataError.posicion}
            type="number"
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormRondas;
